import { render, staticRenderFns } from "./article-class-grid.vue?vue&type=template&id=510dc2a8"
import script from "./article-class-grid.vue?vue&type=script&lang=js"
export * from "./article-class-grid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports